import { getTimeout, getWindow } from '@/helpers/globals'
import { useScriptTag } from '@vueuse/core'

export const useAhrefs = (): void => {
    const window = getWindow()
    const document = window?.document

    if (!document) {
        return
    }

    const { load } = useScriptTag(
        'https://analytics.ahrefs.com/analytics.js',
        undefined,
        {
            async: true,
            attrs: {
                'data-key': 'VaLU0dJo4NmCxAOc0io5Ag',
            },
        }
    )

    const timeout = getTimeout()

    if (timeout) {
        const { setTimeout } = timeout

        setTimeout(async () => {
            await load()
        }, 10_000)
    }
}
